import dompurify from "dompurify";

export const sanitizeHtml = (html: string) => {
  return dompurify.sanitize(html, {
    ALLOWED_TAGS: ["div", "p", "i", "u", "strong", "span"],
  });
};
